module.exports = __webpack_public_path__ + "static/media/hercules.fb19b6f0.jpeg";